// extracted by mini-css-extract-plugin
export default {"root":"EmailVerificationForm_root__2L4EZ","bottomWrapper":"EmailVerificationForm_bottomWrapper__3F9H4"};